/* Drop Art: knock the light box out of the header logo (turns near-white pixels transparent). */
(function () {
  function add() {
    if (document.getElementById('dn-knock-svg')) return;
    document.body.insertAdjacentHTML('beforeend', '<svg id="dn-knock-svg" width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><filter id="dn-knock" color-interpolation-filters="sRGB"><feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  -1.91 -6.44 -0.65 0 8.1" result="k"/><feComposite in="k" in2="SourceAlpha" operator="in"/></filter></svg>');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();
/* Drop Art: flag language switcher in the header (all screen sizes). */
(function () {
  var D = window.dropLang;
  if (!D || !D.langs || D.langs.length < 2) return;
  var FLAGS = {
    nl: '<svg viewBox="0 0 60 40" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><rect width="60" height="14" fill="#AE1C28"/><rect y="13" width="60" height="14" fill="#fff"/><rect y="26" width="60" height="14" fill="#21468B"/></svg>',
    de: '<svg viewBox="0 0 60 40" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><rect width="60" height="14" fill="#000"/><rect y="13" width="60" height="14" fill="#D00"/><rect y="26" width="60" height="14" fill="#FFCE00"/></svg>',
    fr: '<svg viewBox="0 0 60 40" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><rect width="20" height="40" fill="#0055A4"/><rect x="20" width="20" height="40" fill="#fff"/><rect x="40" width="20" height="40" fill="#EF4135"/></svg>',
    en: '<svg viewBox="0 0 60 40" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><rect width="60" height="40" fill="#012169"/><path d="M0 0L60 40M60 0L0 40" stroke="#fff" stroke-width="8"/><path d="M0 0L60 40M60 0L0 40" stroke="#C8102E" stroke-width="3"/><path d="M30 0V40M0 20H60" stroke="#fff" stroke-width="12"/><path d="M30 0V40M0 20H60" stroke="#C8102E" stroke-width="7"/></svg>'
  };
  function flag(iso) { return '<span class="dn-flag">' + (FLAGS[iso] || '<b>' + iso.toUpperCase() + '</b>') + '</span>'; }
  function rootOf(l) { return l.root === '/' ? '' : l.root.replace(/\/$/, ''); }
  var cur = D.langs.filter(function (l) { return l.iso === D.cur; })[0] || D.langs[0];
  function rest() {
    var p = location.pathname, r = rootOf(cur);
    if (r && (p === r || p.indexOf(r + '/') === 0)) p = p.slice(r.length);
    return p || '/';
  }
  function href(l) { return (rootOf(l) + rest()) + location.search + location.hash; }
  function build() {
    var w = document.createElement('div');
    w.className = 'dn-lang';
    w.setAttribute('data-dn-lang', '');
    var items = D.langs.map(function (l) {
      return '<li><a data-nofix hreflang="' + l.iso + '" lang="' + l.iso + '" href="' + href(l) + '"' + (l.iso === cur.iso ? ' aria-current="true"' : '') + '>' + flag(l.iso) + '<span>' + l.name + '</span></a></li>';
    }).join('');
    w.innerHTML = '<button type="button" class="dn-lang__btn" aria-haspopup="true" aria-expanded="false" aria-label="' + D.label + ': ' + cur.name + '">' + flag(cur.iso) + '<svg class="dn-lang__caret" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button><ul class="dn-lang__list" hidden>' + items + '</ul>';
    var btn = w.querySelector('button'), list = w.querySelector('ul');
    /* Keep the dropdown fully inside the viewport (12px margin), whatever side the button sits on. */
    function place() {
      list.style.left = 'auto'; list.style.right = '0';
      var b = btn.getBoundingClientRect(), lw = list.offsetWidth, vw = document.documentElement.clientWidth;
      var wl = w.getBoundingClientRect().left;
      var want = Math.min(Math.max(b.right - lw, 12), vw - lw - 12);
      list.style.right = 'auto';
      list.style.left = (want - wl) + 'px';
    }
    function close() { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = list.hidden;
      list.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) place();
    });
    window.addEventListener('resize', function () { if (!list.hidden) place(); });
    document.addEventListener('click', function (e) { if (!w.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return w;
  }
  function mount() {
    if (document.querySelector('[data-dn-lang]')) return;
    var actions = document.querySelector('#header-component header-actions');
    var el = build();
    if (actions && actions.parentNode) actions.parentNode.insertBefore(el, actions);
    else {
      var cols = document.querySelector('#header-component .header__columns');
      if (cols) cols.appendChild(el);
    }
  }
  function init() {
    mount();
    var g = document.getElementById('header-group');
    if (g) new MutationObserver(mount).observe(g, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* Drop Art: mobile menu drawer gets a wordmark and a shop button. */
(function () {
  var T = { nl: 'Shop de Base Set', de: 'Zum Base Set', fr: 'Découvrir le Base Set' };
  function mountDrawer() {
    var drawer = document.querySelector('#header-component .menu-drawer');
    if (!drawer || drawer.querySelector('.dn-drawer__brand')) return;
    var D = window.dropLang || {}, iso = D.cur || (document.documentElement.lang || 'en').slice(0, 2), root = '';
    (D.langs || []).forEach(function (l) { if (l.iso === iso && l.root !== '/') root = l.root.replace(/\/$/, ''); });
    var brand = document.createElement('a');
    brand.className = 'dn-drawer__brand';
    brand.href = root || '/';
    brand.innerHTML = 'Drop<b>Art</b>.';
    drawer.insertBefore(brand, drawer.firstChild);
    var foot = document.createElement('div');
    foot.className = 'dn-drawer__foot';
    foot.innerHTML = '<a class="dn-drawer__cta" href="' + root + '/collections/gel-printing">' + (T[iso] || 'Shop the Base Set') + '</a>';
    drawer.appendChild(foot);
  }
  function init() {
    mountDrawer();
    var g = document.getElementById('header-group');
    if (g) new MutationObserver(mountDrawer).observe(g, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
